<template>
  <div class="patron-gate">
    <div v-if="patron == false" class="patron-gate__locked">
      <div class="patron-gate__header">
        <div class="patron-gate__icon">
          <i :class="iconClass"></i>
          <span class="patron-gate__lock"><i class="fas fa-lock"></i></span>
        </div>
        <div>
          <div class="patron-gate__eyebrow">
            <i class="fas fa-crown"></i> Premium feature
          </div>
          <h3 class="patron-gate__title">{{ resolvedTitle }}</h3>
          <p class="patron-gate__tagline">{{ resolvedTagline }}</p>
        </div>
      </div>

      <ul v-if="resolvedPoints.length" class="patron-gate__points">
        <li v-for="(point, i) in resolvedPoints" :key="i">
          <i class="fas fa-check"></i>
          <span>{{ point }}</span>
        </li>
      </ul>

      <div class="patron-gate__cta-row">
        <PatreonPremiumButton @track="trackPremiumCTA" />
        <DiscordPremiumButton @track="trackPremiumCTA" />
      </div>

      <p class="patron-gate__foot">
        Already subscribed? <router-link to="/premium">Manage your Premium servers →</router-link>
      </p>
    </div>

    <div v-else class="patron-gate__missing-slot">
      <div class="patron-gate__icon patron-gate__icon--solo">
        <i class="fas fa-star"></i>
      </div>
      <h3 class="patron-gate__title">You're so close.</h3>
      <p class="patron-gate__tagline">
        You have Premium, but this server doesn't have a Premium slot applied yet.
      </p>
      <b-button variant="success" @click="$router.push('/premium')">
        Apply Premium to this server
      </b-button>
    </div>
  </div>
</template>

<script>
import DiscordPremiumButton from "../../components/DiscordPremiumButton.vue";
import PatreonPremiumButton from "../../components/PatreonPremiumButton.vue";

export default {
  name: "PatronCard",
  props: {
    patron: { type: [Boolean, Number], default: false },
    add_premium: { default: null },
    feature: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DiscordPremiumButton,
    PatreonPremiumButton,
  },
  computed: {
    iconClass() {
      return this.feature.icon || "fas fa-gem";
    },
    resolvedTitle() {
      return this.feature.title || "This feature is Premium-only";
    },
    resolvedTagline() {
      return (
        this.feature.tagline ||
        "Unlock the full Carl-bot toolkit and get more out of every server you run."
      );
    },
    resolvedPoints() {
      return this.feature.points || [];
    },
  },
  methods: {
    trackPremiumCTA() {
      this.$emit("track");
    },
  },
};
</script>

<style scoped>
.patron-gate {
  max-width: 640px;
  margin: 24px auto;
}

.patron-gate__locked,
.patron-gate__missing-slot {
  background: linear-gradient(180deg, #2f323d 0%, #2a2d36 100%);
  border: 1px solid rgba(248, 203, 0, 0.2);
  border-radius: 14px;
  padding: 28px 28px 24px;
  position: relative;
}

.patron-gate__header {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  margin-bottom: 18px;
}

.patron-gate__icon {
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: rgba(248, 203, 0, 0.12);
  color: #f8cb00;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}
.patron-gate__icon--solo {
  margin: 0 auto 14px;
}

.patron-gate__lock {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f8cb00;
  color: #1a1430;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  border: 2px solid #2a2d36;
}

.patron-gate__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  background: rgba(248, 203, 0, 0.12);
  border: 1px solid rgba(248, 203, 0, 0.3);
  color: #f8cb00;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 999px;
  margin-bottom: 8px;
}
.patron-gate__eyebrow i {
  font-size: 9px;
}

.patron-gate__title {
  color: #fff;
  font-family: Poppins, sans-serif;
  font-weight: 700;
  font-size: 22px;
  margin: 0 0 4px;
}

.patron-gate__tagline {
  color: #b8b6c8;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.patron-gate__points {
  list-style: none;
  padding: 0;
  margin: 0 0 22px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 16px;
}
.patron-gate__points li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  color: #d8d6e0;
  line-height: 1.45;
}
.patron-gate__points li i {
  margin-top: 3px;
  color: #5ad575;
  font-size: 11px;
  flex-shrink: 0;
}
@media (max-width: 575.98px) {
  .patron-gate__points {
    grid-template-columns: 1fr;
  }
}

.patron-gate__cta-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 14px;
}

.patron-gate__foot {
  text-align: center;
  font-size: 12px;
  color: #888;
  margin: 0;
}
.patron-gate__foot a {
  color: #c2acff;
  font-weight: 600;
  text-decoration: none;
}
.patron-gate__foot a:hover {
  color: #d6c4ff;
  text-decoration: none;
}

.patron-gate__missing-slot {
  text-align: center;
}
.patron-gate__missing-slot .patron-gate__title {
  margin-bottom: 8px;
}
.patron-gate__missing-slot .patron-gate__tagline {
  margin-bottom: 18px;
}
</style>
